import React, { useState, useEffect } from 'react';
import Button from '../../components/shared/buttons/button';
import Datatable from '../../components/shared/datatable/Datatable';
import { useNavigate } from 'react-router';
import { useGetOdoUsersQuery } from '../../app/userApi/userApi';
import { formatDateToMDY } from '../../helpers/Utils';
import { AiOutlineEye } from "react-icons/ai";
const OdoUsers = () => {
  const navigate = useNavigate()
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const { data: surveyList, isLoading, isFetching } = useGetOdoUsersQuery({
    page,
    limit: 10,
    search,
  });

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1); // Reset to first page on new search
  };
  const columns = [
    {
      label: 'Name',
      accessor: 'name',
      cell: ({ row }) => <>{row?.name}</>,
    },
    { label: 'Phone', accessor: 'phone' },
    { label: 'email', accessor: 'email_from' },
    {
      label: 'Survey created at',
      accessor: 'createdAt',
      cell: ({ row }) => <>{formatDateToMDY(row?.create_date)}</>,
    },
      {
                label: "View", accessor: "Action",
                cell: ({ row }) => (
    
                    <div className='d-flex gap-2 align-items-center'>
                        <Button icon={<AiOutlineEye size={24} />} className={'borderedBtn'} size={'xs'} onClick={() => {
                            navigate(`/users/odouser-details/${row?.id}`, {
                                state: { userName: row?.name, userEmail: row?.email_from }
                            });
                        }} />
    
    
                    </div>
                ),
            },
  ];

  return (
    <Datatable
      isLoading={isLoading || isFetching}
      tableData={surveyList?.data}
      columns={columns}
      page={page}
      onPageChange={onPageChange}
      showPegination={true}
      isFetching={isFetching}
      showFilter={true}
      onFilterSearch={handleSearch}
    />
  );
};

export default OdoUsers;
